import { render, staticRenderFns } from "./nullified_show_disclosure.vue?vue&type=template&id=57dff431"
import script from "./nullified_show_disclosure.vue?vue&type=script&lang=js"
export * from "./nullified_show_disclosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports